import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="bg-background-50">
      <Navbar />
      <main>
        <section
          className="relative overflow-hidden flex items-center justify-center"
          style={{ minHeight: "100svh" }}
        >
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage:
                "url('https://readdy.ai/api/search-image?query=Quiet%20ethereal%20abstract%20composition%20with%20delicate%20flying%20manuscript%20pages%20and%20ink%20particles%20drifting%20in%20soft%20warm%20ivory%20light%2C%20gentle%20wind-blown%20scroll%20sheets%20with%20faded%20calligraphy%20floating%20in%20hazy%20atmosphere%2C%20subtle%20warm%20beige%20and%20soft%20amber%20tones%2C%20dreamlike%20literary%20landscape%20with%20abundant%20negative%20space%2C%20purely%20artistic%20non-photographic%20illustration%2C%20serene%20and%20contemplative%20mood%20suitable%20for%20dark%20text%20overlay&width=1600&height=900&seq=qh-notfound-brand-01&orientation=landscape&nocache=true')",
            }}
          />
          <div className="absolute inset-0 bg-white/20" />
          <div className="relative z-10 text-center px-4 w-full">
            <img
              src="https://storage.readdy-site.link/project_files/6517ebfd-0186-45e8-a53b-6a7dda87aef3/6d23f5d8-f2c4-4070-a39b-51782f265262_compressed_logo-02.webp"
              alt="千華駐科技"
              className="h-10 md:h-12 w-auto mx-auto mb-8 object-contain opacity-40"
            />
            <p
              className="font-heading text-[10rem] md:text-[14rem] font-black text-foreground-950/4 leading-none select-none pointer-events-none"
              style={{ textShadow: "0 4px 40px rgba(0,0,0,0.02)" }}
            >
              404
            </p>
            <div className="-mt-6 md:-mt-10">
              <h1
                className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 tracking-wide"
              >
                此頁面不存在
              </h1>
              <p
                className="mt-3 text-sm md:text-base text-foreground-500 max-w-md mx-auto leading-relaxed"
              >
                您嘗試訪問的頁面 <span className="font-mono text-foreground-300">{location.pathname}</span> 可能已被移除或不存在。
              </p>
              <div className="mt-8">
                <a
                  href="/"
                  className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600"
                >
                  <i className="ri-arrow-left-line"></i>
                  返回首頁
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}